var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    { staticClass: "v-table__body" },
    [
      _vm.$slots.header
        ? _c(
            "tr",
            {
              staticClass: "v-table__row v-table__row--header",
              class: [
                _vm.item &&
                _vm.item.type &&
                _vm.item.type.attribute &&
                _vm.item.type.attribute.slug
                  ? "v-table--colorful appointment-" +
                    _vm.item.type.attribute.slug
                  : _vm.item
                  ? "appointment-default v-table--colorful"
                  : ""
              ],
              on: { click: _vm.toggleCollapse }
            },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, { isCollapsed: _vm.localIsCollapsed })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-712e87b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-712e87b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VTableBody.vue
// module id = 326
// module chunks = 1 2